import type { ReactNode } from 'react';
import ChatMarkdown from '@/components/ora/Chat/Companion/ChatMarkdown';
import type { ChatBlock } from '@/slices/chat/chatSlice';
import type { McGrawHillAnswerLayout } from './mcgrawHillQuoteMarkers';

/**
 * mcgraw-hill: a member's answer, text and cards in reading order
 * (layoutMcGrawHillAnswer). Every piece keeps its key from first paint to
 * the end, so nothing above the writing edge remounts or moves.
 */
const McGrawHillAnswerBody = ({
  layout,
  blocks,
  renderBlock,
  isStreaming,
  isTurnRunning,
  watchTokens,
}: {
  layout: McGrawHillAnswerLayout;
  blocks: readonly ChatBlock[];
  renderBlock?: (block: ChatBlock) => ReactNode;
  isStreaming: boolean;
  isTurnRunning: boolean;
  watchTokens: boolean;
}) => {
  const { segments, trailingBlocks } = layout;

  const card = (block: ChatBlock | undefined, key: string) =>
    block && renderBlock ? (
      <div key={key} className="my-3">
        {renderBlock(block)}
      </div>
    ) : null;

  return (
    <>
      {segments.map((segment, index) =>
        segment.kind === 'text' ? (
          <ChatMarkdown
            key={`text-${index}`}
            text={segment.text}
            isStreaming={isStreaming && index === segments.length - 1}
            isTurnRunning={isTurnRunning}
            watchTokens={watchTokens}
          />
        ) : (
          card(
            blocks.find((candidate) => candidate.id === segment.blockId),
            segment.blockId
          )
        )
      )}
      {trailingBlocks.map((block) => card(block, block.id))}
    </>
  );
};

export default McGrawHillAnswerBody;
